// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';
import type { Floor } from '../../../types/OfficesType';

type Props = {
  floors: Floor[],
}

function Floors(props: Props) {
  return (
    <div className="locations-contacts">
      <div className="title">
        <Translate value="OFFICE.FLOORS" />
      </div>
      {
        props.floors.filter(floor => floor.isActive).length > 0
          ? (
            props.floors.filter(floor => floor.isActive)
              .sort((a, b) => a.rank - b.rank)
              .map(floor => (
                <div key={floor.id} className="floor">
                  <div>
                    {floor.label} - {floor.level} - {floor.surface} m² - {floor.descriptionText}
                  </div>
                  <hr />
                </div>
              ))
          ) : (
            <div className="empty-state">
              <Translate value="OFFICE.NO_FLOOR" />
            </div>
          )
      }
    </div>
  );
}

export default Floors;
